<div class="rox-symbol-list card bg-dark-lighter text-white">
  <div class="card-body">
    <div class="row rox-symbol-list__title">
      <div class="col fs-16">
        <span>{{ "IB reward setting" }}</span>
      </div>
    </div>
    <div class="row mt-3 rox-symbol-list__body">
      <div class="col-md-10 col-xs-12 rox-symbol-list__body-filter" >
        <div class="input-group search-group">
          <input
            type="text"
            [(ngModel)]="filter.search"
            class="form-control bg-dark"
            name="keyword"
            placeholder="Search"
          />
          <button 
            class="btn btn-main" 
            type="button" 
            (click)="search()">
            Search
          </button>
        </div>
        <div class="symbol-suffix d-flex align-items-center mr-2">
          <mat-label class="mr-2">Symbol suffix</mat-label>
          <select 
            [(ngModel)]="filter['symbolSuffix']" >
            <option 
              *ngFor="let symbol of symbolSuffixList" 
              [value]="symbol">
              {{symbol}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2 d-flex justify-content-end">
        <button 
          type="submit" 
          class="btn btn-main mr-2 import-csv"
          id="import-btn"
          (click)="chooseFileImportCSV()">
          Import CSV
        </button>
        <input
          id="symbol-list-import-btn"
          class=""
          style="visibility: hidden; width: 0; height: 0; min-width: 0"
          accept=".csv" 
          type="file"
          name="importCsv"
          [(ngModel)]="files"
          #importCsv
          (change)="importCSV(importCsv.files)">
        <button type="submit" class="btn btn-main mr-2 " (click)="apply()">Apply</button>
        <button type="submit" class="btn btn-main" (click)="refresh()">
          Refresh
      </button>
      </div>
    </div>
    <div class="row mt-3 rox-symbol-list__table">
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
              <tr>
                <th class="text-center">Symbol</th>
                <th class="text-center">Total IB Reward</th>
                <th class="text-center">Direct IB reward</th>
                <th class="text-center">Preceding level IB reward</th>
                <th class="text-center">Platform owner reward</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let symbol of symbolList; let i = index">
                <td>{{symbol.symbol}}</td>
                <td>$ {{symbol.total_reward | number: '1.3-3'}}/ {{symbol.volume | number: '1.3-3'}}</td>
                <td>$ {{symbol.direct_ib_reward | number: '1.3-3'}}</td>
                <td>$ {{symbol.preceding_ib_reward | number: '1.3-3'}}</td>
                <td>$ {{symbol.platform_reward | number: '1.3-3'}}</td>
                <td>
                  <i class="fa fa-pencil-square-o mr-2 icon" 
                    (click)="editSymbol(symbol,i)">
                  </i>
                  <i class="fa fa-refresh icon" (click)="openResetDialog(symbol )"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<rox-dialog-prime
  [show]="showEditSymbolDialog"
  [showEditBtn]="symbolDetail.readonly?true:false"
  [titleName]="'IB reward setting'"
  (save)="saveEditSymbolDialog()"
  (close)="closeEditSymbolDialog()"
  (edit)="editSymbolDialog()"
  [showSaveBtn]="(!error && !symbolDetail.readonly)"
  class=""
>
  <content>
      <table>
        <tr class="mb-2">
          <td>  
            <span>Symbol:</span>
          </td>
          <td>
            <span class="ml-2">{{symbolDetail.symbol}}</span>
          </td>
        </tr>
        <tr class="mb-2">
          <td>
            <span>Volume:</span>
          </td>
          <td>  
            <input
              type="text"
              (keyup)="changeReward($event)"
              [disabled]="symbolDetail.readonly?true:false"
              class="mx-2"
              mask="0*.000"
              [dropSpecialCharacters]="false"
              [(ngModel)]="symbolDetail.volume"
          ></td>
        </tr>
        <tr class="mb-2">
          <td>
            <span>Total Ib reward:
              <i 
                class="fa fa-info-circle"
                style="color:black"
                pTooltip="Total IB reward will be calculated correspondingly based on trader trading volume" 
                tooltipPosition="right" 
                tooltipZIndex='99000'
              >
              </i>
            </span>
          </td>
          <td>
            <input 
              type="text"
              (keyup)="changeReward($event)"
              [disabled]="symbolDetail.readonly?true:false"
              class="mx-2"
              [(ngModel)]="symbolDetail.totalIBReward"
              mask="0*.000"
              [dropSpecialCharacters]="false"
            >
            <span>
              USD / {{symbolDetail.volume | number: '1.3-3'}}
            </span>
          </td>
        </tr>
        <tr class="mb-2">
          <td>
            <span>Direct IB reward:</span>
          </td>
          <td>
            <input 
              (keyup)="changeReward($event)"
              type="text"
              [disabled]="symbolDetail.readonly?true:false"
              class="mx-2"
              [(ngModel)]="symbolDetail.directIBReward"
              mask="0*.000"
              [dropSpecialCharacters]="false"
          >
          <span>USD</span>
          </td>
        </tr>
        <tr class="mb-2">
          <td>
            <span>Preceding level IB reward:</span>
          </td>
          <td>
            <input 
              type="text"
              (keyup)="changeReward($event)"
              [disabled]="symbolDetail.readonly?true:false"
              class="mx-2"
              [(ngModel)]="symbolDetail.precedingLevelIBReward"
              mask="0*.000"
              [dropSpecialCharacters]="false"
          >
          <span>USD </span>
          </td>
        </tr>
        <tr class="mb-2">
          <td>
            <span>Platform owner reward:</span>
          </td>
          <td>
            <input 
            [disabled]="true"
            type="text"
            class="mx-2"
            [(ngModel)]="symbolDetail.platformOwnerReward"
          >
          <span>USD </span>
          </td>
        </tr>
      </table>
      <div class="text-red mt-2" *ngIf="error">
        {{error}}
      </div>
  </content>
</rox-dialog-prime>
<rox-dialog-prime
  [show]="showResetDialog"
  (save)="resetSymbol()"
  (close)="cancelResetDialog()"
  [nameApplyBtn]="'Yes'"
  [titleName]="'Reset symbol'"
>
  <content>
    Are you sure that you want to reset this symbol to default setting?
  </content>
</rox-dialog-prime>
<rox-dialog-prime
  [show]="errorImport"
  (close)="errorImport = false"
  [titleName]="'Import Error!'"
  [showSaveBtn]="false"
>
  <content>
      <span [innerHTML]="errorImport"></span>
  </content>
</rox-dialog-prime>